<nz-card>
  <nz-card-meta
    [attr.data-cy]="'card-selection-number-' + title"
    [nzTitle]="titleTpl"
    [nzDescription]="number || '0'"
    [nzAvatar]="iconTemplate"
  ></nz-card-meta>
</nz-card>

<ng-template #titleTpl>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="title">{{ title }}</span>
      <span
        *ngIf="tooltipText"
        nz-tooltip
        [nzTooltipTitle]="tooltipTitleTemplate"
        nz-icon
        class="tooltip-icon"
        nzType="question-circle"
        nzTheme="outline"
      ></span>
    </div>
    <button
      [attr.data-cy]="'card-selection-number-action'"
      *ngIf="actionsText"
      nz-col
      nz-button
      nz-dropdown
      nzType="link"
      [nzDropdownMenu]="actionMenu"
    >
      <span class="more-icon" nz-icon nzType="more" nzTheme="outline"></span>
    </button>
  </div>
</ng-template>

<ng-template #tooltipTitleTemplate>
  <span [innerHTML]="tooltipText"></span>
</ng-template>

<ng-template #iconTemplate>
  <span class="icon-wrapper color-{{ colorType }}">
    <span class="icon" nz-icon [nzType]="icon" nzTheme="outline"></span>
  </span>
</ng-template>

<nz-dropdown-menu #actionMenu="nzDropdownMenu">
  <ul nz-menu>
    <ng-container *ngFor="let actionText of actionsText; let i = index">
      <li nz-menu-item (click)="actionsClicked(i)">{{ actionText }}</li>
    </ng-container>
  </ul>
</nz-dropdown-menu>
